import React from 'react'
import styled from 'styled-components'
import { Link } from 'gatsby'
import iconGo from '@/images/icon-go.svg'

const StH2 = styled.h2`
  position: relative;
  border-bottom: 1px solid #ccc;
  padding: 0.4em 0 0.4em 1em;
  line-height: 1;
  &:before {
    position: absolute;
    left: 0;
    content: '';
    width: 7px;
    background-color: #91252f;
    display: inline-block;
    top: 0;
    bottom: 0;
  }
`

const StLink = styled(Link)`
  position: relative;
  line-height: 1;
  display: block;
  border-bottom: 1px solid #ccc;
  padding: 0.4em 0 0.4em 1em;
  line-height: 1;
  &:before {
    position: absolute;
    left: 0;
    content: '';
    width: 7px;
    background-color: #91252f;
    display: inline-block;
    margin-right: 1rem;
    top: 0;
    bottom: 0;
  }
  &:after {
    content: '';
    background: url(${iconGo}) no-repeat center center;
    display: inline-block;
    height: 0.7em;
    width: 1em;
  }
`

const VotacionTitle = ({ as = 'title', to, className, children }) => {
  if (as === 'link') {
    return (
      <StLink className={className ? className : 'font-bold'} to={to}>
        {children}
      </StLink>
    )
  }
  return <StH2 className={className ? className : 'font-bold'}>{children}</StH2>
}

export default VotacionTitle
